import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('labelbase_token') || null,
    username: localStorage.getItem('labelbase_username') || null,
    products: [],
  },
  mutations: {
    setAuth(state, { token, username }) {
      state.token = token;
      state.username = username;
      localStorage.setItem('labelbase_token', token);
      localStorage.setItem('labelbase_username', username);
    },
    logout(state) {
      state.token = null;
      state.username = null;
      localStorage.removeItem('labelbase_token');
      localStorage.removeItem('labelbase_username');
    },
    setProducts(state, products) {
      state.products = products;
    },
  },
  actions: {
    async fetchProducts({ commit }) {
      const api = (await import('./api')).default;
      try {
        const res = await api.get('/products');
        commit('setProducts', res.data.products);
      } catch {
        // ignore if not logged in
      }
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
});
